import {
  Box,
  LinearProgress,
  Paper,
  Typography,
  useTheme,
} from "@mui/material";

import useStyles from "./styles";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import DatagridComponent from "../../datagridComponent";
import LineChartComponent from "../../lineComponent";
import { Stack } from "@mui/system";

import GaugeGraphComponent from "../../gaugeComponent";

const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");
dayjs.extend(utc);
dayjs.extend(timezone);
const timeZone = "America/Sao_Paulo";
export default function RamGraphComponent(params) {
  const {
    data = [],
    titleGraph,
    loading = false,
    valueRamNow = 0,
    handleAplicarZoom = () => {},
    isZoomEnabled = false,
  } = params;

  const [rows, setRows] = useState([]);
  const [lastValue, setLastValue] = useState(0);
  const theme = useTheme();
  const styles = useStyles(theme);
  const columns = [
    {
      field: "min",
      headerName: "Min",
      width: 60,
      flex: 1,
      valueFormatter: (value) => `${value || 0}%`,
    },
    {
      field: "max",
      headerName: "Max",
      width: 60,
      flex: 1,
      valueFormatter: (value) => `${value || 0}%`,
    },
    {
      field: "avg",
      headerName: "Avg",
      width: 60,
      flex: 1,
      valueFormatter: (value) => `${value || 0}%`,
    },
  ];

  useEffect(() => {
    const lastData = data[data?.length - 1]?.value || 0;

    setLastValue(lastData);

    const values = data?.map((d) => d?.value);
    const min = values?.length > 0 ? Math?.min(...values) : 0;
    const max = values?.length > 0 ? Math?.max(...values) : 0;
    const avg =
      values?.length > 0
        ? values?.reduce((a, b) => a + b, 0) / values?.length
        : 0;

    setRows([
      {
        id: 1,
        ram: "ram",
        min: Math?.round(min),
        max: Math?.round(max),
        avg: Math?.round(avg),
      },
    ]);
  }, [data]);

  const CustomTooltip = ({ active, payload, label }) => {
    if (!active || !payload || payload?.length === 0) return null;

    const { clock, value } = payload[0].payload;

    return (
      <Box
        sx={{
          bgcolor: theme.palette.paletteCharts.lineCharts,
          padding: "8px",
          borderRadius: "8px",
        }}
      >
        <Typography fontSize={"14px"}>
          {dayjs.unix(clock).format("DD/MM/YY HH:mm")}
        </Typography>

        <Stack direction={"row"} alignItems={"center"} gap={"4px"}>
          <Box
            sx={{
              bgcolor:
                theme.palette.cardGraphic.colorPogressLine.light[
                  value > 80
                    ? "red"
                    : value <= 80 && value > 40
                      ? "yellow"
                      : "green"
                ],
              width: "14px",
              height: "14px",
              borderRadius: "2px",
              border: `1px solid ${
                theme.palette.cardGraphic.colorPogressLine.dark[
                  value > 80
                    ? "red"
                    : value <= 80 && value > 40
                      ? "yellow"
                      : "green"
                ]
              }`,
            }}
          />
          <Typography fontSize={"14px"}>
            Em uso: {value?.toFixed(2)}%
          </Typography>
        </Stack>
      </Box>
    );
  };

  const formatRamValue = (value) => {
    return `${value}%`;
  };

  return (
    <Paper
      elevation={theme.palette.mode == "dark" ? 0 : 3}
      sx={{
        ...styles.paper,
        backgroundColor: theme.palette.background.paper,
      }}
    >
      {" "}
      {loading && <LinearProgress sx={styles.linearProgress} />}
      <Box sx={styles.containerComponent}>
        <Typography sx={styles.cardSubText}>{titleGraph}</Typography>

        <Box sx={styles.containerGrid}>
          <Box sx={styles.containerGraph}>
            <Box
              sx={{
                ...styles.containerGraphRam,
                backgroundColor: theme.palette.background.paper,
              }}
            >
              <Box sx={{ padding: 2 }}>
                <Typography sx={{ fontSize: "12px" }}>RAM utilizada</Typography>
              </Box>

              <Box
                sx={{
                  minHeight: "120px",
                  marginBottom: "20px",
                }}
              >
                <Box sx={styles.containerResponsiveContainer}>
                  <GaugeGraphComponent value={valueRamNow} />
                </Box>
              </Box>
              <Box sx={{}}>
                <DatagridComponent
                  rows={rows}
                  columns={columns}
                  options={{ disableColumnSorting: true }}
                />
              </Box>
            </Box>
          </Box>
          <Box sx={{ width: "100%", marginTop: "auto", height: 240 }}>
            <LineChartComponent
              data={data}
              isZoomEnabled={isZoomEnabled}
              onZoomChange={(range) => {
                // Use .unix() para interpretar o valor como segundos
                const startDate = dayjs.unix(range.start).tz(timeZone);
                const endDate = dayjs.unix(range.end).tz(timeZone);

                handleAplicarZoom(startDate, endDate);
              }}
              maxTicks={8}
              mainColor={theme.palette.cardGraphic.graphColor["green"]}
              mainLineColor={theme.palette.cardGraphic.graphLineColor["green"]}
              maxValuebps={100}
              yOptions={{ tickFormatter: formatRamValue, dataKey: "value" }}
              xOptions={{
                dataKey: "clock",
                tickFormatter: (clock) =>
                  dayjs?.unix(clock)?.tz(timeZone)?.format("DD/MM HH:mm"),
              }}
              customTooltip={CustomTooltip}
              areaOptions={{ dataKey: "value" }}
            />
          </Box>
        </Box>
      </Box>
    </Paper>
  );
}
